package com.downdogapp

enum class TextAlign(private val cssValue: String) {

  LEFT("left"),
  CENTER("center"),
  RIGHT("right");

  override fun toString() = cssValue // needed for js
}
